const uploadfile = (state = [], action) => {
    switch (action.type) {
      case 'UPLOADPROGRESS':
      return {
          type: "BLOCK",
          status: action.load
        }       
      default:
        return state
    }
  }
  
  export default uploadfile